<template>
    <div class="radio-wrap-container">
        <label role="radio" :class="['radio-wrap', type]" :disabled="disabled">
            <input value="label"
                type="radio"
                class="radio-original"
                @click="click"
                :disabled="disabled">
            <span :class="[checked ? 'checked' : 'no-checked', 'reo-radio', type, size]" v-show="!myOnlyLabel">
                <span :class="[checkIcon, 'check-icon']"></span>
            </span>
            <span :class="['radio-label', {'underline': myOnlyLabel, 'label-check': checked}]" v-if="label">
                <slot></slot>
            </span>
        </label>
        <span class="text" v-if="text" v-html="text"></span>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({

    props: {

        value: {

            required: true

        },

        type: {

            type: String,
            validator ( type: string ): boolean {

                let types = ['fill', 'original', 'circle', 'highlight'];
                return types.includes( type );

            },
            default (): string {

                return 'original';

            }

        },

        label: {

            required: true

        },

        labelOnSelect: {

            type: String

        },

        onlyLabel: {

            default (): boolean {

                return false;

            }

        },

        size: {

            type: String,
            validator ( type: string ): boolean {

                let types = ['small', 'middle'];
                return types.includes( type );

            },
            default (): string {

                return 'middle';

            }

        },

        text: String,
        disabled: {

            type: Boolean,
            default (): boolean {

                return false;

            }

        }

    },

    data () {

        return {
        };

    },

    methods: {

        click () {

            if ( this.disabled ) {

                return false;

            }
            this.$nextTick(() => {

                this.$emit( 'input', this.label );

            });

        }

    },

    computed: {

        myOnlyLabel (): boolean {

            if ( typeof this.onlyLabel === 'string' ) {

                return true;

            } else {

                return false;

            }

        },
        checked (): boolean {

            return this.label === this.value;

        },
        checkIcon (): string {

            let type = this.type;
            if ( type === 'circle' ) {

                return 'circle-check';

            } else {

                return 'icon-check';

            }

        }

    }

});
</script>

<style lang="less" scoped>
    .radio-wrap-container{
        display: inline-block;
    }
    .radio-wrap{
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
    }
    .reo-radio{
        display: inline-flex;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        background-color: @white;
        box-sizing: border-box;
        border: 1px solid @fill_secondary;
        position: relative;
        vertical-align: middle;
        font-size: 12px;
        &.highlight{
            border-color: @theme;
        }
        &.circle{
            border-radius: 100%;
        }
        &:not(.checked) .check-icon{
            display: none;
        }
        .check-icon{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #fff;
        }
        .circle-check{
            transform: none;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: block;
            height: auto;
            width: auto;
            border: none;
            background-color: @white;
            border-radius: 100%;
            margin: 4px;
        }
        &.fill .check-icon{
            color: #fff;
        }
        &.small{
            width: 16px;
            height: 16px;
            font-size: 12px;
            border-radius: 2px;
        }
        &.small.circle{
            border-radius: 100%;
        }
        @media @mobile{
            &{
                width: 0.24rem;
                height: 0.24rem;
            }
            &.small{
                width: 0.32rem;
                height: 0.32rem;
                border-radius: 0.04rem;
            }
            .check-icon{
                font-size: 0.2rem;
            }
            &.small .check-icon{
                font-size: 0.16rem;
            }
            &.small.circle,
            &.circle{
                width: 0.34rem;
                height: 0.34rem;
                border-radius: 100%;
            }
        }
    }
    .reo-radio.original{
        border-color: #ccc;
    }
    .reo-radio.checked{
        background-color: @brand_light;
        border: none;
    }
    .reo-radio.checked.fill{
        background: @theme-linear-gradient;
        border: none;
    }
    .radio-original{
        opacity: 0;
        outline: none;
        position: absolute;
        margin: 0;
        width: 0;
        height: 0;
        z-index: -1;
    }
    .radio-label{
        font-size: 0.16rem;
        font-weight: 500;
        color: @theme;
        line-height: 0.24rem;
        vertical-align: middle;
        margin-left: 12px;
        vertical-align: bottom;
        &:empty{
            display: none;
        }
    }
    .radio-label.underline.label-check{
        text-decoration: underline;
    }
    .radio-label.underline{
        margin-left: 0;
    }
    @media screen and (max-width:1199px){
        .radio-label{
            margin-left: 10px;
            font-size: .24rem;
        }
    }
    .text{
        margin-left: 0.1rem;
        font-size: 0.16rem;
        vertical-align: middle;
        @media @mobile{
            font-size: 0.24rem;
        }
    }
</style>
